import { JSONEditor } from '@json-editor/json-editor'
import ArrayEditor from './array'
import EventBus from '../../helpers/event-bus'
import _ from 'lodash'

class HotspotEditor extends ArrayEditor {
  constructor (...args) {
    super(...args)
  }

  build () {
    JSONEditor.defaults.editors.array.prototype.build.call(this)
  }

  postBuild () {
    JSONEditor.defaults.editors.array.prototype.postBuild.call(this)
    // setTimeout(() => { // this is necessary to ensure the parent container is ready
    //   const uuid = this.parent?.parent?.container.dataset.hotspotInstance || this.parent?.container.dataset.hotspotInstance || null
    //   console.log('HotspotEditor postBuild UUID', uuid, this.parent?.container?.dataset.hotspotInstance, this.parent?.parent?.container?.dataset.hotspotInstance)
    //   EventBus.$on(`hotspot:dragged${uuid}`, this.updatePostion.bind(this))
    //   EventBus.$on(`hotspot:resized${uuid}`, this.updateSize.bind(this))
    // }, 700) NEEDS TO BE TESTED need to make a choas article to test this

    const parentContainer = this.parent?.parent?.container || this.parent?.container;
    if (!parentContainer) return;

    const setupListeners = () => {
      const uuid = parentContainer.dataset.hotspotInstance || null;
      if (!uuid) return;
      // Remove previous listeners if needed
      EventBus.$off(`hotspot:dragged${uuid}`);
      EventBus.$off(`hotspot:resized${uuid}`);
      // Add listeners
      EventBus.$on(`hotspot:dragged${uuid}`, this.updatePostion.bind(this));
      EventBus.$on(`hotspot:resized${uuid}`, this.updateSize.bind(this));
    };



    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-hotspot-instance') {
          setupListeners(); // Call immediately to ensure listeners are set up
        }
      });
    });

    observer.observe(parentContainer, { attributes: true });
  }

  _createAddRowButton () {
    const button = this.getButton(this.getItemTitle(), 'add', 'button_add_row_title', [this.getItemTitle()])
    button.classList.add('json-editor-btntype-add')
    button.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      const i = this.rows.length
      let editor
      if (this.row_cache[i]) {
        editor = this.rows[i] = this.row_cache[i]
        this.rows[i].setValue(this.rows[i].getDefault(), true)
        // override cached value, so optional properties are not checked.
        if (typeof this.rows[i].deactivateNonRequiredProperties === 'function') {
          this.rows[i].deactivateNonRequiredProperties(true)
        }
        this.rows[i].container.style.display = ''
        if (this.rows[i].tab) this.rows[i].tab.style.display = ''
        this.rows[i].register()
        const uuid = this.parent?.parent?.container.dataset.hotspotInstance || this.parent?.container.dataset.hotspotInstance || null

        EventBus.$emit(`hotspot:added${uuid}`, this.rows[i], uuid)
      } else {
        editor = this.addRow()
      }
      this.active_tab = this.rows[i].tab
      this.refreshTabs()
      this.refreshValue()
      this.onChange(true)
      this.jsoneditor.trigger('addRow', editor)
    })
    this.controls.appendChild(button)
    return button
  }

  async addRow (value, initial) {
    const row = await super.addRow(value, initial)
    const uuid = this.parent?.parent?.container?.dataset.hotspotInstance || this.parent?.container?.dataset.hotspotInstance || null

    EventBus.$emit(`hotspot:added${uuid}`, row, uuid)
    return row
  }

  destroyRow (row) {
    super.destroyRow(row)
    const uuid = this.parent?.parent?.container?.dataset.hotspotInstance || this.parent?.container?.dataset.hotspotInstance || null
    EventBus.$emit(`hotspot:removed${uuid}`, row, uuid)
  }

  onChildEditorChange (editor, eventData) {

    const uuid = this.parent?.parent?.container?.dataset.hotspotInstance || this.parent?.container?.dataset.hotspotInstance || null
    if (!this._debouncedHotspotChanged) {
      this._debouncedHotspotChanged = _.debounce((payload) => {
        EventBus.$emit(`hotspot:changed${uuid || payload.uuid}`, payload)
      }, 100)
    }
    this._debouncedHotspotChanged({
      key: editor.key,
      value: editor.getValue(),
      uuid
    })
    super.onChildEditorChange(editor, eventData)
  }

  updatePostion (el) {
    // Perform any necessary operations on the hotspot element
    if (el.uuid !== this.parent?.parent?.container.dataset.hotspotInstance) {
      console.warn('HotspotEditor updatePostion: Ignoring event for different hotspot instance', el.uuid, this.parent?.parent?.container.dataset.hotspotInstance)
    } else if (el.uuid !== this.parent.container.dataset.hotspotInstance) {
      console.warn('HotspotEditor updatePostion: Ignoring event for different hotspot instance', el.uuid, this.parent.container.dataset.hotspotInstance)
      return
    }
    this.storeValues(el)
    this.refreshValue()
  }

  updateSize (el) {
    if (el.uuid !== this.parent?.parent?.container.dataset.hotspotInstance) {
      console.warn('HotspotEditor updateSize: Ignoring event for different hotspot instance', el)
    } else if (el.uuid !== this.parent.container.dataset.hotspotInstance) {
      console.warn('HotspotEditor updateSize: Ignoring event for different hotspot instance', el)
      return
    }
    this.storeValues(el)
    this.refreshValue()
  }

  getNodePercentages (el) {
    // Extract the translate3d values
    const transform = el.style.transform
    const match = transform.match(/translate3d\(([^,]+)px, ([^,]+)px, [^,]+px\)/)
    const height = el.offsetHeight
    const width = el.offsetWidth
    const parent = el.parentElement
    const img = parent.querySelector('img')
    const parentWidth = img.offsetWidth
    const parentHeight = img.offsetHeight
    const heightPercentage = Number((height / parentHeight) * 100).toFixed(2)
    const widthPercentage = Number((width / parentWidth) * 100).toFixed(2)
    const top = match[2]
    const left = match[1]
    const leftPercentage = Number((left / parentWidth) * 100).toFixed(2)
    const topPercentage = Number((top / parentHeight) * 100).toFixed(2)

    return {
      topPercentage,
      leftPercentage,
      heightPercentage,
      widthPercentage
    }
  }

  storeValues (data) {
    const key = data.el.getAttribute('data-key')
    const { topPercentage, leftPercentage, heightPercentage, widthPercentage } = this.getNodePercentages(data.el)
    const updatedValue = this.rows[key].getValue() // get the current value of the row
    // always update the top/left
    updatedValue.position.top = Number(topPercentage)
    updatedValue.position.left = Number(leftPercentage)
    // only update height/width if they exist
    if ('height' in this.value[key].position) {
      const clampedHeight = Math.min(heightPercentage, 100)
      const clampedWidth = Math.min(widthPercentage, 100)
      // Emit event only if clamping was needed
      if (heightPercentage > 100 || widthPercentage > 100) {
        console.warn(`HotspotEditor: Clamping size for key ${key} to ${clampedWidth}% width and ${clampedHeight}% height`)
        EventBus.$emit(`hotspot:changed${data.uuid}`, {
          key,
          value: { position: { width: clampedWidth, height: clampedHeight } },
          uuid: data.uuid
        })
      }

      updatedValue.position.height = clampedHeight
      updatedValue.position.width = clampedWidth
    }
    this.rows[key].setValue(updatedValue)
  }

  destroy () {
    const uuid = this.parent?.parent?.container?.dataset.hotspotInstance || this.parent?.container?.dataset.hotspotInstance || null
    EventBus.$off(`hotspot:dragged${uuid}`)
    EventBus.$off(`hotspot:resized${uuid}`)
    super.destroy()
  }
}

export default HotspotEditor
